import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const colorSchema = objectOf({
  r: number,
  g: number,
  b: number,
  a: maybe(number),
});

const fontSchema = objectOf({
  name: string,
  fontFamily: string,
  url: maybe(string),
});

const paddingSchema = objectOf({
  top: number,
  right: number,
  bottom: number,
  left: number,
});

const headerStyleSchema = objectOf({
  fontSize: number,
  fontColor: colorSchema,
  textAlign: string,
  textDirection: string,
  font: maybe(fontSchema),
  linkColor: maybe(colorSchema),
});

const widthSchema = objectOf({
  width: number,
});

export const isDragAndDropEditorSettings = objectOf({
  styleSettings: objectOf({
    basicStyling: objectOf({
      emailBackgroundColor: colorSchema,
      contentAreaBackgroundColor: colorSchema,
      font: fontSchema,
      linkColor: colorSchema,
    }),
    titleStyling: objectOf({
      headerStyling: objectOf({
        h1: headerStyleSchema,
        h2: headerStyleSchema,
        h3: headerStyleSchema,
        h4: maybe(headerStyleSchema),
        h5: maybe(headerStyleSchema),
        h6: maybe(headerStyleSchema),
      }),
      blockStyling: objectOf({
        padding: paddingSchema,
      }),
    }),
    buttonStyling: objectOf({
      backgroundColor: colorSchema,
      fontSize: number,
      fontColor: colorSchema,
      borderRadius: number,
      borderColor: colorSchema,
      borderWeight: number,
      padding: paddingSchema,
      blockStyling: objectOf({
        padding: paddingSchema,
      }),
      font: maybe(
        objectOf({
          name: string,
          fontFamily: string,
          url: string,
        })
      ),
    }),
    fallbackFonts: maybe(arrayOf(fontSchema)),
    emailTemplateWidth: maybe(widthSchema),
    contentBlockWidth: maybe(widthSchema),
  }),
});

export const isPostDragAndDropEditorSettingsResult = objectOf({
  success: boolean,
});
